<template>
  <v-dialog max-width="400" persistent v-model="show">
    <v-card>
      <v-card-title
        ><span class="title">Dodaj opunomoćenika</span></v-card-title
      >
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  :label="$t('fields.name') + '*'"
                  outline
                  required
                  v-model="authorizer.name"
                  :rules="[
                    v =>
                      !!v ||
                      $t(
                        'components.authorizerCreate.validation.name.required'
                      ),
                    v =>
                      v.length <= 191 ||
                      $t('components.authorizerCreate.validation.name.length'),
                    v =>
                      !authorizerNames.includes(v.toLowerCase()) ||
                      $t('components.authorizerCreate.validation.name.unique'),
                  ]"
                ></v-text-field>
              </v-flex>
              <v-flex v-show="weighted" xs12>
                <CurrencyField
                  :label="$t('fields.weight')"
                  required
                  v-model="authorizer.weight"
                  v-on:keyup.enter="store"
                ></CurrencyField>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click.stop="close" color="error">{{
          $t('buttons.close')
        }}</v-btn>
        <v-btn @click.stop="store" color="success">{{
          $t('buttons.save')
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Authorizer from '@/models/Authorizer.js'
import CurrencyField from '@/components/trinkets/CurrencyField.vue'

export default {
  props: {
    value: Boolean,
    weighted: Boolean,
    authorizers: Array,
  },

  components: {
    CurrencyField,
  },

  data() {
    return {
      authorizer: new Authorizer(),
      valid: false,
    }
  },

  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },

    authorizerNames() {
      return this.authorizers.map(authorizer => authorizer.name.toLowerCase())
    },
  },

  methods: {
    close() {
      this.show = false

      // Reset validation.
      this.$refs.form.resetValidation()

      // Reset form.
      this.authorizer = new Authorizer()
    },

    store() {
      if (!this.$refs.form.validate()) return

      this.$emit('authorizer-store', new Authorizer(this.authorizer))

      // Close modal.
      this.show = false

      // Reset validation.
      this.$refs.form.resetValidation()

      // Reset form.
      this.authorizer = new Authorizer()
    },
  },
}
</script>
